import { defineMessages } from "locales/defineMessages";

// Users management screens, sign-in and first-login setup.
export default defineMessages({
  vi: {
    "signIn.subtitle":
      "Truy cập hệ thống OmniSport bằng email và mật khẩu để quản lý lớp học, điểm danh và báo cáo hằng ngày.",
    "signIn.phoneSubtitle":
      "Đăng nhập nhanh bằng email hoặc số điện thoại để tiếp tục các tác vụ quản lý và điều hành trung tâm.",
    "signIn.identifierLabel": "Email, SĐT hoặc tên đăng nhập",
    "signIn.identifierPlaceholder": "Email, số điện thoại hoặc username",
    "usersMgmt.userNotFound": "Không tìm thấy người dùng.",
    "firstLogin.selfieFront": "Chính diện",
    "firstLogin.selfieLeft": "Nghiêng trái",
    "firstLogin.selfieRight": "Nghiêng phải",
    "firstLogin.errorProcessPhoto": "Không thể xử lý ảnh vừa chụp",
    "firstLogin.errorUploadAvatar": "Không thể tải ảnh đại diện",
    "firstLogin.errorAvatarNetwork": "Mạng không ổn định khi tải avatar",
    "firstLogin.cameraError":
      "Không thể truy cập camera. Vui lòng kiểm tra quyền truy cập.",
    "firstLogin.uploadFailed": "Upload thất bại",
    "firstLogin.deletePhotoFailed": "Xóa ảnh thất bại",
    "firstLogin.errorFullNameRequired": "Vui lòng nhập họ tên",
    "firstLogin.errorSelfiesRequired":
      "Vui lòng chụp và tải lên đủ 3 ảnh selfie: chính diện, trái, phải",
    "firstLogin.errorActivate": "Không thể hoàn tất thiết lập",
    "firstLogin.title": "Thiết lập tài khoản lần đầu",
    "firstLogin.subtitleManager":
      "Đổi mật khẩu (tùy chọn) và đăng ký khuôn mặt để kích hoạt tài khoản.",
    "firstLogin.subtitle":
      "Hoàn tất thông tin, đổi mật khẩu (tùy chọn), và tải đủ ảnh selfie để kích hoạt tài khoản.",
    "firstLogin.stepPassword": "Mật khẩu mới",
    "firstLogin.stepProfile": "Thông tin profile",
    "firstLogin.stepFace": "Đăng ký khuôn mặt",
    "firstLogin.stepAvatarSelfie": "Avatar & selfie",
    "firstLogin.passwordHint":
      "Bạn có thể đổi mật khẩu hoặc bỏ qua để giữ mật khẩu hiện tại.",
    "firstLogin.newPasswordPlaceholder":
      "Tối thiểu 8 ký tự (để trống nếu không đổi)",
    "firstLogin.confirmPassword": "Xác nhận mật khẩu",
    "firstLogin.fullName": "Họ tên",
    "firstLogin.fullNamePlaceholder": "Nguyễn Văn A",
    "firstLogin.selectGender": "Chọn giới tính",
    "firstLogin.staffProfile": "Hồ sơ huấn luyện viên / quản lý",
    "firstLogin.bioPlaceholder": "Giới thiệu",
    "firstLogin.baseSalaryPlaceholder": "Lương cơ bản",
    "firstLogin.studentProfile": "Hồ sơ học viên",
    "firstLogin.parentPhonePlaceholder": "SĐT phụ huynh",
    "firstLogin.medicalNotePlaceholder": "Ghi chú y tế",
    "firstLogin.nextStepHint":
      "Tiếp tục sang bước 3 để tải ảnh selfie bắt buộc trước khi kích hoạt tài khoản.",
    "firstLogin.avatarOptional": "Avatar (không bắt buộc)",
    "firstLogin.avatarPreviewAlt": "Xem trước avatar",
    "firstLogin.noAvatar": "Chưa có avatar",
    "firstLogin.chooseAvatar": "Chọn ảnh avatar",
    "firstLogin.selfiesTitle": "3 ảnh selfie bắt buộc",
    "firstLogin.selfiesHint":
      "Chụp lần lượt từng góc. Ảnh sẽ được tải lên ngay sau khi xác nhận.",
    "firstLogin.selfiesDone": "Đã chụp đủ 3 ảnh selfie!",
    "firstLogin.selfieStepLabel": "Bước {step}: {title}",
    "firstLogin.selfieStepDone": "{title} - Đã hoàn thành",
    "firstLogin.uploading": "Đang tải lên...",
    "firstLogin.capturedAlt": "Ảnh vừa chụp",
    "firstLogin.confirmUpload": "Xác nhận & Tải lên",
    "firstLogin.processing": "Đang xử lý...",
    "firstLogin.selfieTip":
      "Mẹo: đưa mặt lại gần camera, chiếm phần lớn khung hình, đủ sáng và không bị che khuất.",
    "firstLogin.activate": "Lưu và kích hoạt tài khoản",
    "usersMgmt.create.roleTrainerLabel": "HLV (Huấn luyện viên)",
    "usersMgmt.create.roleTrainerDesc":
      "Huấn luyện viên chịu trách nhiệm dạy lớp",
    "usersMgmt.create.roleTeacherDesc":
      "Người quản lý buổi học và ghi danh học viên",
    "usersMgmt.create.roleStudentDesc": "Người tham gia học lớp",
    "usersMgmt.create.roleManagerDesc":
      "Quản lý toàn bộ hoạt động của trung tâm",
    "usersMgmt.create.errorCenterRequired": "Vui lòng chọn trung tâm",
    "usersMgmt.create.errorCreate": "Không thể tạo người dùng",
    "usersMgmt.create.title": "Tạo người dùng mới",
    "usersMgmt.create.role": "Vai trò",
    "usersMgmt.create.center": "Trung tâm",
    "usersMgmt.create.selectCenter": "-- Chọn trung tâm --",
    "usersMgmt.create.fullNamePlaceholder": "Nhập họ tên",
    "usersMgmt.create.username": "Tên đăng nhập",
    "usersMgmt.create.optional": "Tùy chọn",
    "usersMgmt.create.usernameAutoHint":
      "Tự động tạo từ mã trung tâm + số thứ tự",
    "usersMgmt.create.password": "Mật khẩu",
    "usersMgmt.create.passwordPlaceholder": "Mặc định: {password}",
    "usersMgmt.create.hidePassword": "Ẩn",
    "usersMgmt.create.showPassword": "Hiện",
    "usersMgmt.create.passwordHint":
      "Tối thiểu 8 ký tự. Để trống sẽ dùng mật khẩu mặc định.",
    "usersMgmt.create.sendEmail": "Gửi email thông tin đăng nhập",
    "usersMgmt.create.skipFirstLogin": "Bỏ qua bước đổi mật khẩu lần đầu",
    "usersMgmt.create.infoSkipFirstLogin":
      "Tài khoản sẽ được tạo và người dùng có thể đăng nhập ngay mà không cần đổi mật khẩu.",
    "usersMgmt.create.infoFirstLogin":
      "Tài khoản sẽ được tạo với mật khẩu đã chọn. Người dùng sẽ phải đổi mật khẩu ở lần đăng nhập đầu tiên.",
    "usersMgmt.create.creating": "Đang tạo...",
    "usersMgmt.create.submit": "Tạo người dùng",
    "usersMgmt.enroll.loadClassesError": "Không tải được danh sách lớp.",
    "usersMgmt.enroll.classFallback": "Lớp",
    "usersMgmt.enroll.title": "Chọn lớp & buổi học",
    "usersMgmt.enroll.selectionCount": "{classes} lớp · {sessions} buổi",
    "usersMgmt.enroll.classChip": "Lớp: {name}",
    "usersMgmt.enroll.deselectClass": "Bỏ chọn lớp {name}",
    "usersMgmt.enroll.sessionChip": "Buổi: {time} ({className})",
    "usersMgmt.enroll.deselectSession": "Bỏ chọn buổi {name}",
    "usersMgmt.enroll.searchPlaceholder": "Tìm theo tên hoặc mã lớp...",
    "usersMgmt.enroll.loadingClasses": "Đang tải lớp…",
    "usersMgmt.enroll.noClasses": "Chưa có lớp nào trong trung tâm.",
    "usersMgmt.enroll.noMatchingClasses":
      "Không tìm thấy lớp khớp với từ khóa.",
    "usersMgmt.enroll.remainingSessions": "Số buổi còn lại",
    "usersMgmt.enroll.remainingSessionsPlaceholder": "Nhập số buổi",
    "usersMgmt.enroll.loadingSessions": "Đang tải buổi học…",
    "usersMgmt.enroll.noSessions": "Không có buổi học.",
    "usersMgmt.enroll.noOpenSessions": "Lớp này không có buổi đang mở.",
    "usersMgmt.enroll.sessionFallback": "Buổi học",
    "usersMgmt.table.moreActions": "Thêm thao tác",
    "usersMgmt.table.setPassword": "Đặt mật khẩu",
    "usersMgmt.table.deactivate": "Vô hiệu hóa",
    "usersMgmt.table.activate": "Kích hoạt",
    "usersMgmt.table.allRoles": "Tất cả vai trò",
    "usersMgmt.table.allStatuses": "Tất cả trạng thái",
    "usersMgmt.table.filterActive": "Đang hoạt động",
    "usersMgmt.table.filterInactive": "Đã vô hiệu hóa",
    "usersMgmt.table.footerShowing": "Hiển thị {count} người dùng",
    "usersMgmt.table.title": "Người dùng ({count})",
    "usersMgmt.table.subtitle":
      "Quản lý tài khoản của quản lý trung tâm, quản lý lớp và huấn luyện viên.",
    "usersMgmt.table.searchPlaceholder": "Tìm kiếm người dùng...",
    "usersMgmt.table.clearSearch": "Xóa tìm kiếm",
    "usersMgmt.table.allCenters": "Tất cả trung tâm",
    "usersMgmt.table.status": "Trạng thái",
    "usersMgmt.table.emptyFiltered":
      "Không tìm thấy người dùng khớp với bộ lọc hiện tại.",
    "usersMgmt.table.empty": "Chưa có người dùng nào.",
    "usersMgmt.table.selectAll": "Chọn tất cả ({count})",
    "usersMgmt.table.noName": "Chưa có tên",
    "usersMgmt.table.notFirstLoggedIn": "Chưa đăng nhập lần đầu",
    "usersMgmt.table.noEmail": "Chưa có email",
    "usersMgmt.table.updatedAt": "Cập nhật: {time}",
    "usersMgmt.table.statusActive": "Hoạt động",
    "usersMgmt.table.statusInactive": "Vô hiệu hóa",
    "usersMgmt.table.viewProfile": "Xem hồ sơ",
    "usersMgmt.table.deleteForbidden": "Bạn không có quyền xóa người dùng này",
    "usersMgmt.table.deleteUser": "Xóa người dùng",
    "usersMgmt.setPasswordFailed": "Đặt mật khẩu thất bại",
    "usersMgmt.toggleFailed": "Không thể thay đổi trạng thái",
    "usersMgmt.deleteFailed": "Không thể xóa người dùng",
    "usersMgmt.bulkDeleteFailed": "Không thể xóa {failed}/{total} người dùng.",
    "usersMgmt.setPasswordTitle": "Đặt mật khẩu mới",
    "usersMgmt.setPasswordSuccess": "Đặt mật khẩu thành công!",
    "usersMgmt.newPasswordPlaceholder": "Mật khẩu mới (tối thiểu 8 ký tự)",
    "usersMgmt.roleChange.title": "Xác nhận thay đổi vai trò",
    "usersMgmt.roleChange.confirm":
      "Bạn có chắc muốn chuyển vai trò của {name} thành {role}?",
    "usersMgmt.roleChange.failed": "Thay đổi vai trò thất bại",
    "usersMgmt.toggle.deactivateTitle": "Vô hiệu hóa người dùng?",
    "usersMgmt.toggle.activateTitle": "Kích hoạt người dùng?",
    "usersMgmt.toggle.deactivateBody":
      "Người dùng {name} sẽ không thể đăng nhập cho đến khi được kích hoạt lại.",
    "usersMgmt.toggle.activateBody":
      "Người dùng {name} sẽ có thể đăng nhập trở lại.",
    "usersMgmt.delete.title": "Xóa người dùng?",
    "usersMgmt.delete.body":
      "{name} sẽ bị xóa vĩnh viễn khỏi hệ thống, cùng với toàn bộ dữ liệu liên quan (điểm danh, ghi danh lớp học, báo cáo, thông báo). Hành động này không thể hoàn tác.",
    "usersMgmt.delete.deleting": "Đang xóa...",
    "usersMgmt.bulkDelete.title": "Xóa {count} người dùng?",
    "usersMgmt.bulkDelete.body":
      "Các tài khoản đã chọn sẽ bị xóa vĩnh viễn khỏi hệ thống, cùng với toàn bộ dữ liệu liên quan (điểm danh, ghi danh lớp học, báo cáo, thông báo). Hành động này không thể hoàn tác.",
    "usersMgmt.bulkDelete.submit": "Xóa {count} người dùng",
    "usersMgmt.faceEnroll.subtitle":
      "{name} · Hoàn tất đăng ký rồi có thể chọn lớp/buổi ngay bên cạnh.",
    "usersMgmt.faceEnroll.skip": "Bỏ qua",
    "usersMgmt.faceEnroll.missingRemaining":
      "Vui lòng nhập số buổi còn lại cho {count} lớp đã chọn.",
    "usersMgmt.faceEnroll.studentFallback": "học viên",
    "usersMgmt.faceEnroll.addedClassesAndSessions":
      "Đã thêm {name} vào {classes} lớp và {sessions} buổi học.",
    "usersMgmt.faceEnroll.addedClasses": "Đã thêm {name} vào {classes} lớp.",
    "usersMgmt.faceEnroll.addedSessions":
      "Đã thêm {name} vào {sessions} buổi học.",
    "usersMgmt.faceEnroll.finish": "Hoàn tất",
  },
  en: {
    "signIn.subtitle":
      "Sign in to OmniSport with your email and password to manage classes, attendance and daily reports.",
    "signIn.phoneSubtitle":
      "Sign in quickly with your email or phone number to continue managing your center.",
    "signIn.identifierLabel": "Email, phone or username",
    "signIn.identifierPlaceholder": "Email, phone number or username",
    "usersMgmt.userNotFound": "User not found.",
    "firstLogin.selfieFront": "Front",
    "firstLogin.selfieLeft": "Turn left",
    "firstLogin.selfieRight": "Turn right",
    "firstLogin.errorProcessPhoto": "Couldn't process the captured photo",
    "firstLogin.errorUploadAvatar": "Couldn't upload the avatar",
    "firstLogin.errorAvatarNetwork":
      "Unstable network while uploading the avatar",
    "firstLogin.cameraError":
      "Can't access the camera. Please check camera permissions.",
    "firstLogin.uploadFailed": "Upload failed",
    "firstLogin.deletePhotoFailed": "Failed to delete photo",
    "firstLogin.errorFullNameRequired": "Please enter your full name",
    "firstLogin.errorSelfiesRequired":
      "Please capture and upload all 3 selfies: front, left and right",
    "firstLogin.errorActivate": "Couldn't complete setup",
    "firstLogin.title": "First-time account setup",
    "firstLogin.subtitleManager":
      "Change your password (optional) and register your face to activate your account.",
    "firstLogin.subtitle":
      "Complete your profile, change your password (optional) and upload all selfies to activate your account.",
    "firstLogin.stepPassword": "New password",
    "firstLogin.stepProfile": "Profile details",
    "firstLogin.stepFace": "Face registration",
    "firstLogin.stepAvatarSelfie": "Avatar & selfies",
    "firstLogin.passwordHint":
      "You can change your password or skip this step to keep the current one.",
    "firstLogin.newPasswordPlaceholder":
      "At least 8 characters (leave blank to keep current)",
    "firstLogin.confirmPassword": "Confirm password",
    "firstLogin.fullName": "Full name",
    "firstLogin.fullNamePlaceholder": "John Doe",
    "firstLogin.selectGender": "Select gender",
    "firstLogin.staffProfile": "Trainer / manager profile",
    "firstLogin.bioPlaceholder": "Bio",
    "firstLogin.baseSalaryPlaceholder": "Base salary",
    "firstLogin.studentProfile": "Student profile",
    "firstLogin.parentPhonePlaceholder": "Parent's phone",
    "firstLogin.medicalNotePlaceholder": "Medical notes",
    "firstLogin.nextStepHint":
      "Continue to step 3 to upload the required selfies before activating your account.",
    "firstLogin.avatarOptional": "Avatar (optional)",
    "firstLogin.avatarPreviewAlt": "Avatar preview",
    "firstLogin.noAvatar": "No avatar",
    "firstLogin.chooseAvatar": "Choose avatar",
    "firstLogin.selfiesTitle": "3 required selfies",
    "firstLogin.selfiesHint":
      "Capture each angle in turn. Each photo is uploaded as soon as you confirm it.",
    "firstLogin.selfiesDone": "All 3 selfies captured!",
    "firstLogin.selfieStepLabel": "Step {step}: {title}",
    "firstLogin.selfieStepDone": "{title} - Done",
    "firstLogin.uploading": "Uploading...",
    "firstLogin.capturedAlt": "Captured photo",
    "firstLogin.confirmUpload": "Confirm & upload",
    "firstLogin.processing": "Processing...",
    "firstLogin.selfieTip":
      "Tip: move closer so your face fills most of the frame, with good lighting and nothing covering it.",
    "firstLogin.activate": "Save and activate account",
    "usersMgmt.create.roleTrainerLabel": "Trainer",
    "usersMgmt.create.roleTrainerDesc":
      "Trainer responsible for teaching classes",
    "usersMgmt.create.roleTeacherDesc":
      "Manages sessions and student enrollment",
    "usersMgmt.create.roleStudentDesc": "Attends classes",
    "usersMgmt.create.roleManagerDesc": "Manages all center operations",
    "usersMgmt.create.errorCenterRequired": "Please select a center",
    "usersMgmt.create.errorCreate": "Couldn't create user",
    "usersMgmt.create.title": "Create new user",
    "usersMgmt.create.role": "Role",
    "usersMgmt.create.center": "Center",
    "usersMgmt.create.selectCenter": "-- Select center --",
    "usersMgmt.create.fullNamePlaceholder": "Enter full name",
    "usersMgmt.create.username": "Username",
    "usersMgmt.create.optional": "Optional",
    "usersMgmt.create.usernameAutoHint":
      "Auto-generated from center code + sequence number",
    "usersMgmt.create.password": "Password",
    "usersMgmt.create.passwordPlaceholder": "Default: {password}",
    "usersMgmt.create.hidePassword": "Hide",
    "usersMgmt.create.showPassword": "Show",
    "usersMgmt.create.passwordHint":
      "At least 8 characters. Leave blank to use the default password.",
    "usersMgmt.create.sendEmail": "Email login details",
    "usersMgmt.create.skipFirstLogin": "Skip first-login password change",
    "usersMgmt.create.infoSkipFirstLogin":
      "The account will be created and the user can sign in right away without changing the password.",
    "usersMgmt.create.infoFirstLogin":
      "The account will be created with the chosen password. The user must change it on first sign-in.",
    "usersMgmt.create.creating": "Creating...",
    "usersMgmt.create.submit": "Create user",
    "usersMgmt.enroll.loadClassesError": "Couldn't load the class list.",
    "usersMgmt.enroll.classFallback": "Class",
    "usersMgmt.enroll.title": "Select classes & sessions",
    "usersMgmt.enroll.selectionCount":
      "{classes} classes · {sessions} sessions",
    "usersMgmt.enroll.classChip": "Class: {name}",
    "usersMgmt.enroll.deselectClass": "Deselect class {name}",
    "usersMgmt.enroll.sessionChip": "Session: {time} ({className})",
    "usersMgmt.enroll.deselectSession": "Deselect session {name}",
    "usersMgmt.enroll.searchPlaceholder": "Search by class name or code...",
    "usersMgmt.enroll.loadingClasses": "Loading classes…",
    "usersMgmt.enroll.noClasses": "This center has no classes yet.",
    "usersMgmt.enroll.noMatchingClasses": "No classes match your search.",
    "usersMgmt.enroll.remainingSessions": "Remaining sessions",
    "usersMgmt.enroll.remainingSessionsPlaceholder": "Enter sessions",
    "usersMgmt.enroll.loadingSessions": "Loading sessions…",
    "usersMgmt.enroll.noSessions": "No sessions.",
    "usersMgmt.enroll.noOpenSessions": "This class has no open sessions.",
    "usersMgmt.enroll.sessionFallback": "Session",
    "usersMgmt.table.moreActions": "More actions",
    "usersMgmt.table.setPassword": "Set password",
    "usersMgmt.table.deactivate": "Deactivate",
    "usersMgmt.table.activate": "Activate",
    "usersMgmt.table.allRoles": "All roles",
    "usersMgmt.table.allStatuses": "All statuses",
    "usersMgmt.table.filterActive": "Active",
    "usersMgmt.table.filterInactive": "Deactivated",
    "usersMgmt.table.footerShowing": "Showing {count} users",
    "usersMgmt.table.title": "Users ({count})",
    "usersMgmt.table.subtitle":
      "Manage accounts for center managers, class managers and trainers.",
    "usersMgmt.table.searchPlaceholder": "Search users...",
    "usersMgmt.table.clearSearch": "Clear search",
    "usersMgmt.table.allCenters": "All centers",
    "usersMgmt.table.status": "Status",
    "usersMgmt.table.emptyFiltered": "No users match the current filters.",
    "usersMgmt.table.empty": "No users yet.",
    "usersMgmt.table.selectAll": "Select all ({count})",
    "usersMgmt.table.noName": "No name",
    "usersMgmt.table.notFirstLoggedIn": "Hasn't signed in yet",
    "usersMgmt.table.noEmail": "No email",
    "usersMgmt.table.updatedAt": "Updated: {time}",
    "usersMgmt.table.statusActive": "Active",
    "usersMgmt.table.statusInactive": "Deactivated",
    "usersMgmt.table.viewProfile": "View profile",
    "usersMgmt.table.deleteForbidden":
      "You don't have permission to delete this user",
    "usersMgmt.table.deleteUser": "Delete user",
    "usersMgmt.setPasswordFailed": "Failed to set password",
    "usersMgmt.toggleFailed": "Couldn't change status",
    "usersMgmt.deleteFailed": "Couldn't delete user",
    "usersMgmt.bulkDeleteFailed": "Couldn't delete {failed} of {total} users.",
    "usersMgmt.setPasswordTitle": "Set new password",
    "usersMgmt.setPasswordSuccess": "Password set successfully!",
    "usersMgmt.newPasswordPlaceholder": "New password (at least 8 characters)",
    "usersMgmt.roleChange.title": "Confirm role change",
    "usersMgmt.roleChange.confirm":
      "Are you sure you want to change {name}'s role to {role}?",
    "usersMgmt.roleChange.failed": "Failed to change role",
    "usersMgmt.toggle.deactivateTitle": "Deactivate user?",
    "usersMgmt.toggle.activateTitle": "Activate user?",
    "usersMgmt.toggle.deactivateBody":
      "{name} won't be able to sign in until reactivated.",
    "usersMgmt.toggle.activateBody": "{name} will be able to sign in again.",
    "usersMgmt.delete.title": "Delete user?",
    "usersMgmt.delete.body":
      "{name} will be permanently deleted along with all related data (attendance, class enrollments, reports, notifications). This can't be undone.",
    "usersMgmt.delete.deleting": "Deleting...",
    "usersMgmt.bulkDelete.title": "Delete {count} users?",
    "usersMgmt.bulkDelete.body":
      "The selected accounts will be permanently deleted along with all related data (attendance, class enrollments, reports, notifications). This can't be undone.",
    "usersMgmt.bulkDelete.submit": "Delete {count} users",
    "usersMgmt.faceEnroll.subtitle":
      "{name} · Finish registration, then pick classes/sessions alongside.",
    "usersMgmt.faceEnroll.skip": "Skip",
    "usersMgmt.faceEnroll.missingRemaining":
      "Please enter remaining sessions for {count} selected classes.",
    "usersMgmt.faceEnroll.studentFallback": "the student",
    "usersMgmt.faceEnroll.addedClassesAndSessions":
      "Added {name} to {classes} classes and {sessions} sessions.",
    "usersMgmt.faceEnroll.addedClasses": "Added {name} to {classes} classes.",
    "usersMgmt.faceEnroll.addedSessions":
      "Added {name} to {sessions} sessions.",
    "usersMgmt.faceEnroll.finish": "Finish",
  },
});
